import React from "react";
import { ScrollArea } from "../../../../../../components/ScrollBar";

interface ScrollableContainerProps {
  children: React.ReactNode;
}

const ScrollableContainer: React.FC<ScrollableContainerProps> = ({
  children,
}) => {
  return <ScrollArea height={"320px"}>{children}</ScrollArea>;
};

export default ScrollableContainer;
